import ProductDetailsPage from "../../features/product-details/product-details-page";
import "../../styles/scss/product-details.scss";
export default function ProductDetails() {
  return <ProductDetailsPage />;
}
